var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar-chart"},[_c('div',{staticClass:"bar-chart__container"},[_c('canvas',{ref:"chartRequirements"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }